import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { config } from 'src/app/config/config';



@Injectable({
  providedIn: 'root'
})
export class ClientService {

  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };
  config = config;
  savedannxAList: any[] = [];
  formData = new FormData();

  constructor(private http: HttpClient) { }

  getClientCategory() {
    let URL = environment.URL + this.config.URL.getClientCategory;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);
  }

  downloadSampleFile() {
    let URL = environment.URL + this.config.URL.downloadSampleFile;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,this.options);
  }

  uploadAnnexure(file,reqId) {
    let URL = environment.URL + this.config.URL.uploadAnnexure;
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('reqId', reqId);
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, formData, this.options);
  }
 

  registerClient(requestObject: any){
    let URL = environment.URL + this.config.URL.register;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }


  getRegisteredClients(requestObject: any){
    let URL = environment.URL + this.config.URL.getRegisteredClients;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }


  addannxAList(annxAList: any[]) {
    this.savedannxAList = annxAList;
  }


  getAnnexureADetailsByAnxrId(id: String) {
    return this.savedannxAList.find(data => data.anxrId == id);
  }

  clientApproveReject(clientID: String, action: String){
    let URL = environment.URL + this.config.URL.clientApproveReject+"?clientID="+clientID+"&action="+action;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,this.options);
  }

  getClientsForSegment(eligibleSegment: String){
    let URL = environment.URL + this.config.URL.getClientsForSegment+"?eligibleSegment="+eligibleSegment;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL,this.options);
  }

}
